export const truncate = (text: string, maxLength: number): string => {
    if(text === undefined || text === null) return '';
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
};
